import Vue from 'vue';

export default ({ user, subject }) => Vue.authorizationChecker.isGranted('role-moderator') && user.id !== subject.id && subject.muted !== undefined && !subject.muted;
